import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { PlatformService } from 'src/app/services/platform.service';

// Keep this URL in sync with the preload in src/index.html.
const PASSPORT_SCRIPT_URL =
  'https://teuteuf-web-components.pages.dev/teuteuf-passport-offer.js';

@Component({
  selector: 'app-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport.component.scss'],
})
export class PassportComponent implements AfterViewInit {
  @ViewChild('offerHost', { static: true })
  offerHost!: ElementRef<HTMLDivElement>;

  constructor(private platform: PlatformService) {}

  ngAfterViewInit(): void {
    if (!this.platform.isInBrowser()) return;
    this.loadScript();
    this.renderOffer();
  }

  private loadScript(): void {
    if (document.querySelector('script[data-teuteuf-passport-offer]')) return;

    const script = document.createElement('script');
    script.src = PASSPORT_SCRIPT_URL;
    script.crossOrigin = 'anonymous';
    script.setAttribute('data-teuteuf-passport-offer', '');
    script.async = true;
    document.body.appendChild(script);
  }

  private renderOffer(): void {
    const locale = (navigator.language || 'en').split('-')[0];
    const theme = document.documentElement.classList.contains('dark')
      ? 'dark'
      : 'light';

    this.offerHost.nativeElement.innerHTML =
      `<teuteuf-passport-offer lang="${locale}" referer="wheretaken" ` +
      `loginHref="/passport" authServerUrl="https://auth.teuteuf.fr" theme="${theme}"></teuteuf-passport-offer>`;
  }
}
